import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Delivery from "./api/delivery";
import Store from "./api/store";
import Qrcode from "./api/qrcode";

import instance from "./main";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: ["guid", "userInfo", "zipCode"]
        }),
        createPersistedState({
            paths: [
                "deliveryMenu",
                "categoryKeys",
                "deliveries",
                "categories",
                "carts",
                "isLogin",
                "storeInfo",
                "storeId",
                "tableGuid",
                "tableNum",
                "token",
                "lang",
                "tokenContent",
                "tableArea",
                "activeTableAreaGuid",
                "tableList",
                "languageList",
                "languageListAll"
            ],
            storage: window.sessionStorage
        })
    ],
    state: {
        isTheme1: false, //针对个别店铺单独设置的样式（暗色背景） 在该模式下顶部无app引导下载 已经无顶部banner图
        isBuffet: Number(sessionStorage.getItem('isBuffet')) || null, //当前订单是否为自助订单 null 未知  1 正常下单  2 自助下单
        buffetRoundSetting: JSON.parse(sessionStorage.getItem("buffetRoundSetting") || "{}"),
        isLogin: false,
        storeId: undefined,
        tableGuid: undefined,
        // process.env.NODE_ENV === "development"
        //   ? "b21dd4fe4b484a76a0108ffa4d7bfb4f"
        //   : undefined,
        showCookie: true,
        // 用户 id
        guid: null,
        tokenContent: null,
        userInfo: null,
        categories: {},
        categoryKeys: [],
        deliveries: {},
        deliveryMenu: [],
        currentDelivery: null,
        carts: [],
        storePayment: [],
        storeInfo: {
            address: {},
            logo: {}
        },
        languages: [
            {
                icon: "China.png",
                title: "简体中文",
                value: "zh-CN"
            },
            {
                icon: "Spina.png",
                title: "Español",
                value: "es-ES"
            }
        ],
        language: localStorage.getItem("language") || "es-ES",
        zipCode: null,

        // 服务器获取的购物车信息
        cartsInfo: {
            actuallyPaidAmount: 0
        },

        // 获取某个桌子的当前未支付的订单内容
        myOrder: {
            items: []
        },

        // 已点菜品 含加菜列表
        orderList: [],

        tableNum: "",

        lang: "",

        // 区域
        tableArea: [],

        // 选中的区域
        activeTableAreaGuid: "",

        // 桌位列表
        tableList: [],

        // 点餐页选中的菜品分类
        activeCategory: 0,
        activeCategoryIndex: 0,

        // 来自商家app点餐'store' or 扫码点餐
        pageFrom: location.href.includes('localhost') ? "" : '',
        languageList: [], //启用的语言列表
        languageListAll: [], //包含未启用的语言列表
        languageListVal: [
            "es-ES",
            "italian",
            "portuguese",
            "english",
            "french",
            "german",
            "zh-CN"
        ],
        declarationData: null
    },
    getters: {
        getLanguageIndex(state) {
            let language = state.language;
            let languageListVal = state.languageListVal;
            return languageListVal.findIndex(item => item === language) || 0;
        },
        getTranslateIndex(state) {
            let language = state.language;
            let languageListVal = state.languageListVal;
            let val = languageListVal.findIndex(item => item === language) || 0;
            return (
                (state.languageListAll || []).findIndex(
                    item => item.enable && item.val === val + 1
                ) || 0
            );
        },
        categoryList(state) {
            let recommendedCommodites = {
                category_name_json: {
                    "es-ES": 'RECOMENDACIÓN',
                    "italian": '商家推荐',
                    "portuguese": '商家推荐',
                    "english": 'Recommended',
                    "french": 'Recommandé',
                    "german": 'Von Händlern empfohlen',
                    "zh-CN": '商家推荐'
                },
                categoryGuid: 'recommended',
                commodites: [],
                guid: 'recommended',
                name: '商家推荐'
            };
            let categoryList = state.categoryKeys.map((item, index) => {
                let goods = state.categories[item] && state.categories[item].commodites || [];
                goods.forEach(item=>{
                    if(item.recommended){
                        recommendedCommodites.commodites.push({...item});
                    }
                })
                return {
                    ...state.categories[item],
                    guid: state.categories[item] && state.categories[item].guid + index,
                    categoryGuid: state.categories[item] && state.categories[item].guid
                };
            });
            if(recommendedCommodites.commodites && recommendedCommodites.commodites.length)categoryList.unshift(recommendedCommodites);
            return categoryList;
        },
        currentDelivery(state) {
            return state.deliveries[state.currentDelivery] || {};
        },
        cart(state) {
            let subtotal = 0;
            const items = state.carts.map(item => {
                if(!state.deliveries || !state.deliveries[item.guid]){
                    return {
                        ...item,
                    };
                }
                const delivery = JSON.parse(JSON.stringify(state.deliveries[item.guid]));
                // 处理选中的菜品属性
                let attrPrice = 0;
                if (item.attributes && item.attributes.length != 0) {
                    delivery.attributes_cate.forEach((cate, cateIndex)=>{
                        if(cate.attributes){
                            cate.attributes.forEach((item2, index) => {
                                delivery.attributes_cate[cateIndex].attributes[index].check = false;
                                if(item.attributes.includes(item2.guid)){
                                    delivery.attributes_cate[cateIndex].attributes[index].check = true;
                                    attrPrice += Number(delivery.attributes_cate[cateIndex].attributes[index].price);
                                }
                            });
                        }
                    })
                }

                // 处理选中的套餐内菜品
                let garnishAttrPrice = 0;
                if (item.garnish && item.garnish.length) {
                    delivery.garnish.forEach((garnish_item, garnish_index) => {
                        garnish_item.commodity.forEach(
                            (commodity_item, commodity_index) => {
                                item.garnish.map(item => {
                                    if ((item && item.commodity_guid) === commodity_item.commodity_guid) {
                                        delivery.garnish[garnish_index].commodity[commodity_index].check = true;
                                        garnishAttrPrice += Number(delivery.garnish[garnish_index].commodity[commodity_index].price);
                                    }
                                });
                            }
                        );
                    });
                }

                subtotal += item.num * parseFloat(delivery.price);

                return {
                    ...item,
                    delivery,
                    price_attr_total: (Number(item.price) + attrPrice + garnishAttrPrice).toFixed(2),
                };
            });

            console.log(items)
            return {
                items,
                subtotal
            };
        },
        payStatusList() {
            return {
                "0": instance.$t("pay_status.un_paid"),
                "1": instance.$t("pay_status.partial"),
                "2": instance.$t("pay_status.paid"),
                "3": instance.$t("pay_status.partial_refund"),
                "4": instance.$t("pay_status.refund")
            };
        },
        orderStatusList() {
            return {
                "0": instance.$t("order_status.wait"),
                "1": instance.$t("order_status.packet"),
                "2": instance.$t("order_status.on_the_way"),
                "3": instance.$t("order_status.arrived"),
                "4": instance.$t("order_status.completed"),
                "5": instance.$t("order_status.settled"),
                "6": instance.$t("order_status.refund")
            };
        },
        declarationData(state){
            return state.declarationData;
        }
    },
    mutations: {
        login(state) {
            state.isLogin = true;
        },
        setDeclarationData(state, data) {
            state.declarationData = data;
        },
        changeBuffet(state, buffet){
            state.isBuffet = buffet;
            sessionStorage.setItem('isBuffet', buffet);
        },
        setTheme1(state){
            state.isTheme1 = true;
            document.body.style.backgroundColor = '#2A2B32';
            sessionStorage.setItem('isTheme1', '1')
        },
        setBuffetRound(state, data){
            sessionStorage.setItem('buffetRoundSetting', JSON.stringify(data))
            state.buffetRoundSetting = data;
        },
        logout(state) {
            state.isLogin = false;
            state.guid = null;
            state.tokenContent = null;
            state.userInfo = null;
        },
        setGuid(state, guid) {
            state.guid = guid;
        },
        setZipCode(state, zipCode) {
            state.zipCode = zipCode;
        },
        setStoreId(state, storeId) {
            state.storeId = storeId;
        },
        setTableGuid(state, tableGuid) {
            state.tableGuid = tableGuid;
        },
        setTokenContent(state, token) {
            state.tokenContent = token;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setCategories(state, categories) {
            state.categories = JSON.parse(JSON.stringify(categories));
        },
        setCategoryKeys(state, categoryKeys) {
            state.categoryKeys = JSON.parse(JSON.stringify(categoryKeys));
        },
        setDeliveries(state, deliveries) {
            state.deliveries = JSON.parse(JSON.stringify(deliveries));
        },
        setCurrentDelivery(state, guid) {
            state.currentDelivery = guid;
        },
        setDelivery(state, delivery) {
            state.deliveries[delivery.guid] = {
                ...delivery
            };
        },
        setDeliveryMenu(state, menu) {
            state.deliveryMenu = JSON.parse(JSON.stringify(menu));
        },
        setCartsInfo(state, cartsInfo) {
            state.cartsInfo = cartsInfo;
        },

        // 接收服务器返回后更新购物车
        resetCart(state, payload) {
            state.carts = payload;
        },
        addToCart(state, payload) {
            let index = null;

            if (payload.index != undefined) {
                index = payload.index;
            } else {
                index = state.carts.findIndex(item => {
                    return item.guid === payload.guid;
                });
            }

            //判断加的菜品是否重复 属性配菜等等
            let sameIndex = -1;
            if (payload.index != undefined){
                sameIndex = index;
            }
            state.carts.forEach((item, _index)=>{
                if(sameIndex === -1 && (item.guid === payload.guid) && checkSameGoods(payload, item)){
                    sameIndex = _index;
                }
            })
            if(sameIndex !== -1){
                let goodsData = state.deliveries[payload.guid]
                if(!state.carts[sameIndex].is_threshold && instance.$reachDishLimitPrice(goodsData)){
                    let _sameIndex = state.carts.findIndex(it=>{
                        return it.guid === payload.guid && it.is_threshold;
                    });
                    if(_sameIndex === -1){
                        state.carts.push({
                            ...state.carts[sameIndex],
                            price: goodsData.commodityPricing.price,
                            is_threshold: 1,
                            num: 1
                        });
                    }else{
                        state.carts[_sameIndex].num += payload.num;
                    }
                }else{
                    state.carts[sameIndex].num += payload.num;
                }
            }else{
                state.carts.push(payload);
            }
        },
        minusFromCart(state, payload) {
            let index = null;

            if (payload.index != undefined) {
                index = payload.index;

                let is_threshold = false;
                let existIndex = state.carts.findLastIndex(item => {
                    if(item.guid === payload.guid){
                        is_threshold = item.is_threshold;
                    }
                    return item.guid === payload.guid;
                });
                if(existIndex !== index && (existIndex>index) && is_threshold){
                    index = existIndex;
                }
            } else {
                index = state.carts.findLastIndex(item => {
                    return item.guid === payload.guid;
                });
            }

            if (index === -1) {
                return;
            }

            const cart = state.carts[index];
            const num = cart.num - payload.num;

            if (num <= 0) {
                state.carts.splice(index, 1);
                return;
            }

            state.carts[index].num = num;
        },
        removeFromCart(state, guid) {
            const index = state.carts.findIndex(item => {
                return item.guid === guid;
            });

            if (index === -1) {
                return;
            }

            state.carts.splice(index, 1);
        },
        clearCart(state) {
            state.carts = [];
        },
        setStorePayment(state, payment) {
            state.storePayment = payment;
        },

        /**
         * 保存店铺信息
         * @param {*} state
         * @param {*} storeInfo
         */
        setStoreInfo(state, storeInfo) {
            state.storeInfo = storeInfo;
            let list = JSON.parse(
                (storeInfo.storeConf && storeInfo.storeConf.lang) || "[]"
            ) || [];
            state.languageList = list.filter(item => item.enable);
            state.languageListAll = list;
        },

        closeCookie(state) {
            state.showCookie = false;
        },

        setLanguage(state, language) {
            state.language = language;
        },

        setMyOrder(state, myOrder) {
            state.myOrder = myOrder;
        },

        setOrderList(state, orderList) {
            state.orderList = orderList;
        },

        setTableNum(state, tableNum) {
            state.tableNum = tableNum;
        },

        setLang(state, lang) {
            state.lang = lang;
        },

        setTableArea(state, tableArea) {
            state.tableArea = tableArea;
        },

        setActiveTableAreaGuid(state, activeTableAreaGuid) {
            state.activeTableAreaGuid = activeTableAreaGuid;
        },

        setTableList(state, tableList) {
            state.tableList = tableList;
        },

        setActiveCategoryIndex(state, activeCategory) {
            state.activeCategoryIndex = activeCategory;
        },

        setPageFrom(state, pageFrom) {
            state.pageFrom = pageFrom;
        }
    },
    actions: {
        /**
         * 获取菜品分类
         * @param {*} param0
         */
        async getDeliveryCategory({state, commit}) {
            try {
                const {
                    data: {isError, data}
                } = await Delivery.getDeliveryCategory({storeGuid: state.storeId});

                if (isError) {
                    return;
                }

                const categoryKeys = [];
                const categories = {};

                data.forEach(item => {
                    const {guid} = item;
                    categoryKeys.push(guid);
                    categories[guid] = item;
                });

                commit("setCategories", categories);
                commit("setCategoryKeys", categoryKeys);
            } catch (e) {
                console.log(e);
            }
        },

        /**
         * 获取菜品分类列表 - 新
         * @param {*} param0
         */
        async getDeliveries({state, commit, dispatch}, buffet) {
            //在有菜品数据的情况下不再次发起请求
            if(state.deliveryMenu && state.deliveryMenu.length) return ;

            let { data: { isError, data: cateGoryList } } = await Delivery.getDeliveryCategory2({
                buffet: state.isBuffet === 2 ? 1 : 0
            });
            if(isError) return ;

            const categoryKeys = [];
            const categories = {};
            const deliveryMenu = [];

            cateGoryList.forEach(item=>{
                const {guid, ...category} = item;
                categoryKeys.push(guid);
                const menu = {
                    guid,
                    ...category
                };
                categories[guid] = {
                    ...menu
                };
                deliveryMenu.push(menu);
                dispatch('getDeliveriesList', {
                    categoryGuid: item.guid,
                    buffet
                })
            })
            commit("setCategoryKeys", categoryKeys);
            commit("setCategories", categories);
            commit("setDeliveryMenu", deliveryMenu);
        },

        /**
         * 获取菜品列表
         * @param {*} param0
         */
        async getDeliveriesList({state, commit}, payload) {
            const { categoryGuid, buffet } = payload;
            try {
                const {
                    data: {isError, data}
                } = await Delivery.getDeliveries({
                    storeGuid: state.storeId,
                    isQRCode: 1,
                    serialNumber: state.tableNum,
                    buffet,
                    categoryGuid
                });
                if (isError) return;

                let { categories, deliveryMenu, deliveries } = state;

                categories[categoryGuid].commodites = JSON.parse(JSON.stringify(data));
                deliveryMenu.find(item=>item.guid === categoryGuid).commodites = data.map(delivery => {
                    if (delivery.images && delivery.images.length > 0) {
                        delivery.cover = delivery.images[0];
                    } else {
                        delivery.cover = {};
                    }

                    deliveries[delivery.guid] = delivery;
                    return delivery;
                });

                let recommendedCommodites = {
                    category_name_json: {
                        "es-ES": 'RECOMENDACIÓN',
                        "italian": '商家推荐',
                        "portuguese": '商家推荐',
                        "english": '商家推荐',
                        "french": '商家推荐',
                        "german": '商家推荐',
                        "zh-CN": '商家推荐'
                    },
                    categoryGuid: 'recommended',
                    commodites: [],
                    guid: 'recommended',
                    name: '商家推荐'
                };
                deliveryMenu.forEach(cate=>{
                    if(cate.guid === 'recommended') return ;
                    if(cate.commodites){
                        cate.commodites.forEach(good=>{
                            if(good.recommended){
                                recommendedCommodites.commodites.push({...good});
                            }
                        })
                    }
                })
                if(recommendedCommodites.commodites && recommendedCommodites.commodites.length) {
                    categories['recommended'] = { ...recommendedCommodites, commodites: undefined };
                    let index = deliveryMenu.findIndex(it=>it.guid === 'recommended');
                    if(index !== -1) deliveryMenu.splice(index, 1);
                    deliveryMenu.unshift(recommendedCommodites);
                }
                commit("setCategories", categories);
                commit("setDeliveries", deliveries);
                commit("setDeliveryMenu", deliveryMenu);
            } catch (e) {
                console.log(e);
            }
        },

        /**
         * 获取菜品详情
         * @param {*} param0
         */
        async getDeliveryDetail({state, commit}, payload) {
            try {
                const {
                    data: {isError, data}
                } = await Delivery.getDeliveryDetail({
                    ...payload,
                    serialNumber: state.tableNum,
                    buffet: state.isBuffet === 2 ? 1 : 0
                });

                if (isError) {
                    return;
                }

                data.cover =
                    data.images && data.images.length > 0 ? data.images[0] : {};
                commit("setDelivery", data);
                commit("setCurrentDelivery", payload.guid);
            } catch (e) {
                console.log(e);
            }
        },

        /**
         * 获取支付方式
         * @param {*} param0
         */
        async getStorePayment({state, commit}) {
            try {
                const {
                    data: {isError, data}
                } = await Store.getStorePayment({storeGuid: state.storeId});

                if (isError) {
                    return;
                }

                commit("setStorePayment", data);
            } catch (e) {
                console.log(e);
            }
        },

        async getBuffetRound({state, commit}, callBack){
            console.log(callBack);
            const {
                data: {isError, data}
            } = await Store.getBuffetRound({storeGuid: state.storeId});

            if (isError) {
                return;
            }
            commit("setBuffetRound", data);
        },

        /**
         * 获取店铺信息
         * @param {*} param0
         */
        async getStoreInfo({state, commit}, callBack) {
            try {
                let {
                    data: {isError: isError2, data:dataDeclarationData}
                } = await Store.getDeclaration({
                    guid: state.storeId,
                    storeId: state.storeId,
                    storeGuid: state.storeId,
                    type: 4
                });
                if(!isError2 && dataDeclarationData && dataDeclarationData.title && dataDeclarationData.content){
                    commit("setDeclarationData", dataDeclarationData);
                }
                const {
                    data: {isError, data}
                } = await Store.getStoreInfo({guid: state.storeId});

                if (isError) {
                    return;
                }

                callBack && callBack(data);

                const info = {
                    ...data
                };
                if(info.scanCodeStyle && info.scanCodeStyle.style === 'dark'){
                    commit("setTheme1");
                }
                window.timeZone = info.storeConf && info.storeConf.timeZone;

                const title = state.tableNum
                    ? info.name + "-" + state.tableNumm
                    : info.name;

                document.title = title;

                if (info.images && info.images.length > 0) {
                    info.images.forEach(item => {
                        if (item.imageTypeStr == "Logo") {
                            info.logo = {
                                ...item
                            };
                        } else if (item.imageTypeStr == "Background") {
                            info.background = {
                                ...item
                            };
                        }
                    });
                }

                commit("setStoreInfo", info);
            } catch (e) {
                console.error(e);
            }
        },

        /**
         * 处理购物车加减 更新服务器端购物车
         * @param {*} param0
         */
        async updateQrcodeCart({state, getters}) {
            // 请求加入购物车
            let payload = {
                tableGuid: state.tableGuid,
                items: getters.cart.items.map(item => {
                    let attributes = [];
                    item.delivery.attributes_cate.map(cate => {
                        (cate.attributes || []).map(item=>{
                            if (item.check) {
                                attributes.push(item.guid);
                            }
                        })
                    });

                    return {
                        commodityGuid: item.delivery.guid,
                        quantity: item.num,
                        is_threshold: item.is_threshold?1:0,
                        attributes,
                        garnish: item.garnish
                    };
                })
            };

            if (payload.items.length == 0) {
                payload.items = [];
            }

            try {
                const {
                    data: {isError}
                } = await Qrcode.addCart({
                    ...(payload || {}),
                    buffet: state.isBuffet === 2 ? 1 : 0
                });
                if (isError) {
                    return;
                }
            } catch (e) {
                console.error(e);
            }
        },

        /**
         * 获取服务器购物车内容
         */
        async getQrcodeCart({state, commit}) {
            try {
                const {
                    data: {isError, data}
                } = await Qrcode.loadCart({
                    tableGuid: state.tableGuid
                });

                if (isError) {
                    return;
                }

                if (data) {
                    let payload = JSON.parse(data).result.items.map(item => {
                        return {
                            ...item,
                            num: item.quantity,
                            price: item.price,
                            guid: item.commodityGuid,
                            attributes: item.attributes,
                            garnish: item.garnish
                        };
                    });

                    commit("setCartsInfo", JSON.parse(data).result);
                    commit("resetCart", payload);
                } else {
                    commit("resetCart", []);
                }
            } catch (e) {
                console.error(e);
            }
        },

        /**
         * 获取某个桌子的当前未支付的订单内容
         */
        async getMyOrder({state, commit}) {
            try {
                const {
                    data: {isError, data, msg}
                } = await Qrcode.loadMyOrder({
                    tableGuid: state.tableGuid
                });

                window.tableIsNotExisted = msg === '该桌子不存在';

                if (isError) {
                    alert(msg)
                    return;
                }
                if(data && data.type == 5){
                    commit("changeBuffet", 2);
                }else if(data){
                    commit("changeBuffet", 1);
                }
                // try{
                //     if(state.isBuffet === 2 && (!data || !data.guid)){
                //         alert(instance.$t("checkout.open-order"));
                //     }
                // }catch (e) {
                //     console.log(e)
                // }
                commit("setMyOrder", data || {items: []});

                let orderList = [];

                if (data && data.items) {
                    data.items.map(item => {
                        orderList[item.seq] = [];
                    });
                    data.items.map(item => {
                        let totalPrice = (item.attributes || []).reduce((total, attr) => {
                            if(attr.price){
                                return Number(attr.price) + total;
                            }
                            return total
                        }, Number(item.total));
                        item.totalPrice = totalPrice;
                        orderList[item.seq].push(item);
                    });
                }
                commit("setOrderList", orderList);
            } catch (e) {
                console.error(e);
            }
        }
    }
});

function conpareArray(arr1 = [], arr2 = []) {
    let result = true;
    result = (arr1.length === arr2.length);
    arr1.map(item => {
        if (!arr2.includes(item)) {
            result = false
        }
    })
    return result;
}

//检查传入的两个商品是否相同 主要用于添加菜品
function checkSameGoods(newGoods, oldGoods){
    let same = true;
    if(newGoods.garnish && newGoods.garnish.length){
        if (newGoods.garnish && newGoods.garnish.length) {
            for (let i = 0; i < oldGoods.garnish.length; i++) {
                let id = oldGoods.garnish[i].commodity_guid;
                if (!newGoods.garnish.find(_val => _val.commodity_guid === id)) {
                    same = false;
                    break;
                }
                //如果菜品数量相等 再判断菜品具体的属性
                let attr = oldGoods.garnish[i].attributes_guid;
                let index = newGoods.garnish.findIndex(_val => _val.commodity_guid === id);
                let _attr = newGoods.garnish[index].attributes_guid;
                if (!conpareArray(attr || [], _attr || [])) {
                    same = false;
                }
            }
        } else {
            same = false;
        }
    }
    if (newGoods.attributes && newGoods.attributes.length) {
        if (!conpareArray(newGoods.attributes || [], oldGoods.attributes || [])) {
            same = false;
        }
    }
    if(newGoods.price !== oldGoods.price) same = false;
    return same;
}